import React, { useEffect, useState } from "react";
import { adminFetch } from "../../api/adminApi";
import { AdminCard, AdminLabel, AdminPageHeader } from "./AdminPageHeader";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({
    email: "",
    password: "",
    role: "writer",
  });

  const load = async () => {
    const data = await adminFetch("/v1/admin/users");
    setUsers(data.users || []);
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await load();
      } catch (e) {
        if (!cancelled) setErr(e.message);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    try {
      await adminFetch("/v1/admin/users", {
        method: "POST",
        body: JSON.stringify(form),
      });
      setForm({ email: "", password: "", role: "writer" });
      await load();
    } catch (e) {
      setErr(e.data?.error || e.message);
    }
  };

  return (
    <div>
      <AdminPageHeader
        kicker="Team"
        title="Team accounts"
        description="Add writers to your team. To create an admin account, contact your system administrator."
      />

      {err && (
        <div className="mb-6 rounded-xl border border-red-500/30 bg-red-500/10 px-4 py-3 text-sm text-red-300">
          {err}
        </div>
      )}

      <AdminCard className="mb-10">
        <h2 className="mb-6 text-[10px] font-black uppercase tracking-[0.25em] text-slate-500">
          Invite user
        </h2>
        <form
          onSubmit={submit}
          className="flex flex-col gap-5 md:flex-row md:flex-wrap md:items-end"
        >
          <div className="min-w-[200px] flex-1">
            <AdminLabel>Email</AdminLabel>
            <input
              type="email"
              className="pitch-admin-input"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>
          <div className="min-w-[180px] flex-1">
            <AdminLabel>Password (min 8)</AdminLabel>
            <input
              type="password"
              className="pitch-admin-input"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
              minLength={8}
            />
          </div>
          <input type="hidden" name="role" value="writer" />
          <button type="submit" className="pitch-admin-btn-primary w-full md:w-auto">
            Add user
          </button>
        </form>
      </AdminCard>

      <AdminCard>
        <h2 className="mb-6 text-[10px] font-black uppercase tracking-[0.25em] text-slate-500">
          Directory
        </h2>
        <ul className="divide-y divide-white/[0.06]">
          {users.map((u) => (
            <li
              key={u.id}
              className="flex flex-wrap items-center justify-between gap-3 py-4 first:pt-0"
            >
              <span className="font-mono-data text-sm text-slate-200">
                {u.email}
              </span>
              <span
                className={
                  u.role === "admin"
                    ? "pitch-admin-badge pitch-admin-badge--writer"
                    : "pitch-admin-badge pitch-admin-badge--goalise"
                }
              >
                {u.role}
              </span>
            </li>
          ))}
        </ul>
      </AdminCard>
    </div>
  );
}